module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm02t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Praise for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Favorite Son")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“INTENSELY PLOTTED, FAST-MOVING.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fm022"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“EXCITING, SCANDALOUS.”")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“EXTREMELY GOOD READING.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fm022"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Washington Post Book World")])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“THE INTRIGUE WHIPS ALONG.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fm022"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Los Angeles Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“OUTSTANDING.”")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—Cincinnati Post")])]), _vm._v(" "), _c('p', {
    staticClass: "fm021"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“TOP-NOTCH THRILLER FICTION … IRRESISTIBLE.”")])]), _vm._v(" "), _c('p', {
    staticClass: "fm022"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Booklist")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c02d48e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm02.vue
// module id = 69
// module chunks = 0